// src/js/config/ui/loadConfigModal.js

import { DOMElements } from '../dom.js';
import { populateConfigSelect } from './populateConfigSelect.js';
import { showMessage, hideMessage } from './showMessage.js';
import { toggleConfigurationSource } from './toggleConfigurationSource.js';
import { loadConfigData } from '../configLoader.js';
import { loadConfigurationIntoForm } from '../configFormHandler.js';
import { activateTrap, deactivateTrap } from '../../utils/focusTrap.js';

let currentModal, originalTrigger;

function hideModal() {
    if (currentModal) {
        deactivateTrap();
        if (originalTrigger) originalTrigger.focus();
        currentModal.classList.remove('is-visible');
        document.body.classList.remove('modal-open');
        currentModal = null;
        originalTrigger = null;
    }
}

export function showLoadConfigModal() {
    const { loadConfigModal, selectConfig } = DOMElements;
    if (!loadConfigModal) return;
    originalTrigger = document.activeElement;
    currentModal = loadConfigModal;
    populateConfigSelect();
    toggleConfigurationSource('select');
    loadConfigModal.classList.add('is-visible');
    document.body.classList.add('modal-open');
    activateTrap(loadConfigModal);
    if (selectConfig) selectConfig.focus();
}

export function initializeLoadConfigModal() {
    const { loadConfigModal, loadConfigBtn, orderConfigSourceRadios, selectConfig, configFileUpload, fileNameDisplay } = DOMElements;
    if (!loadConfigModal) return;

    loadConfigBtn.addEventListener('click', async () => {
        hideMessage();
        const selectedRadio = Array.from(orderConfigSourceRadios).find(radio => radio.checked);
        const sourceType = selectedRadio ? selectedRadio.value : null;
        const valueOrFile = sourceType === 'select' ? selectConfig.value : configFileUpload.files[0];
        const result = await loadConfigData(sourceType, valueOrFile);

        if (result.success) {
            const { configData, configName } = result.data;
            const wasConverted = loadConfigurationIntoForm(configData);
            hideModal();

            const strings = window.SimP_Strings || {};
            let message;
            let messageType = 'success';

            if (wasConverted) {
                messageType = 'warning';
                // Använder den nya, dedikerade strängen
                message = (strings.load_config_success_flex_converted || "Flex-val borttagna och '%s' laddad.").replace('%s', configName);
            } else {
                // Använder den vanliga success-strängen
                message = (strings.load_config_success || "Konfiguration '%s' har laddats.").replace('%s', configName);
            }
            
            showMessage(message, messageType);

        } else {
            showMessage(result.message, result.isWarning ? 'info' : 'error');
        }
    });

    if (configFileUpload) {
        configFileUpload.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                if (fileNameDisplay) fileNameDisplay.textContent = file.name;
                if (loadConfigBtn) loadConfigBtn.disabled = false;
                hideMessage();
            } else {
                if (fileNameDisplay) fileNameDisplay.textContent = 'No file chosen';
                if (loadConfigBtn) loadConfigBtn.disabled = true;
            }
        });
    }

    orderConfigSourceRadios.forEach(radio => {
        radio.addEventListener('change', () => toggleConfigurationSource(radio.value));
    });

    loadConfigModal.addEventListener('click', (e) => {
        if (e.target.closest('#cancelLoadBtn') || e.target === loadConfigModal) {
            hideModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && loadConfigModal.classList.contains('is-visible')) {
            hideModal();
        }
    });
}